export default __webpack_public_path__ + "static/media/g-breakpoint.95e626ea.jpg";